export default function formatNumber(number, fixTo = 1) {
  if (typeof number !== 'number') return '-';
  const roundedNumber = number?.toFixed(fixTo);
  return Number(roundedNumber)?.toLocaleString('en-US');
}
